import axios from 'axios'

var http = axios.create({
	baseURL: process.env.API_BASE_URL + '/duel',
	headers: { 'Content-Type': 'application/json' }
})

http.interceptors.response.use(function (response) {
	return response
}, function (error) {
	if (error.response.status !== 401) return Promise.reject(error)

	var refreshAndRetry = new Promise(function (resolve) {
		axios.post(process.env.API_BASE_URL + '/account/refresh_token',
			{
				'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
			},
			{
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
				}
			}).then(function (response) {
				localStorage.setItem('refresh_token', JSON.stringify({
					value: response.data.refresh_token,
					expire: null
				}))

				localStorage.setItem('token', JSON.stringify({
					value: response.data.token,
					expire: null
				}))

				return Promise.resolve(response)
			}).then(function (response) {
				var failedRequest = error.config
				failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
				axios.request(failedRequest).then(function (retryResponse) {
					resolve(retryResponse)
				})
			})
	})

	return refreshAndRetry
})

function getConfig() {
	return {
		headers: {
			'Authorization': JSON.parse(localStorage.getItem('token')).value
		}
	}
}

function getSeason(callback) {
	var config = getConfig()

	http.get('/list_season', config)
		.then(function (response) {
			callback({
				success: true,
				data: response.data
			})
		}).catch(function (error) {
			callback({
				success: false,
				message: error.message
			})
		})
}

function getSeasonDetail(id, callback) {
	var config = getConfig()

	http.get('/season_detail/' + id, config)
		.then(function (response) {
			callback({
				success: true,
				data: response.data
			})
		}).catch(function (error) {
			callback({
				success: false,
				message: error.message
			})
		})
}

function addSeason(data, callback) {
	var config = getConfig()
	var param = {
		name: data.name,
		description: data.description,
		picture: data.picture,
		started_at: data.started_at,
		ended_at: data.ended_at,
	}

	http.post('/add_season', param, config)
		.then(function (response) {
			callback({
				success: true,
				data: response.data
			})
		}).catch(function (error) {
			callback({
				success: false,
				data: error.response.data,
				message: error.message
			})
		})
}

function updateSeason(id, data, callback) {
	var config = getConfig()
	var param = {
		id: id,
		name: data.name,
		description: data.description,
		picture: data.picture,
		started_at: data.started_at,
		ended_at: data.ended_at,
	}

	http.put('/edit_season', param, config)
		.then(function (response) {
			callback({
				success: true,
				data: response.data
			})
		}).catch(function (error) {
			callback({
				success: false,
				data: error.response.data,
				message: error.message
			})
		})
}

function deleteSeason(id, callback) {
	var config = getConfig()

	http.delete('/delete_season/' + id, config)
		.then(function (response) {
			callback({
				success: true,
				data: response.data
			})
		}).catch(function (error) {
			callback({
				success: false,
				message: error.message
			})
		})
}

export default {
	getSeason,
	getSeasonDetail,
	addSeason,
	updateSeason,
	deleteSeason,
}


// WEBPACK FOOTER //
// ./src/services/duel.js